import React, {  } from 'react';
import {  } from 'antd';
import { useSelector } from "react-redux";


import './style/publicize.less';


const publiciceBanner = require('../../assets/images/publicize/publicizeBanner.jpg');
const publicize1 = require('../../assets/images/publicize/publicize1.jpg');
const publicize2 = require('../../assets/images/publicize/publicize2.jpg');
const publicize3 = require('../../assets/images/publicize/publicize3.jpg');
const publicizeFooter = require('../../assets/images/publicize/publicizeFooter.jpg');

const pzmobile01 = require('../../assets/images/publicize/mobile/pz-mobile01.jpg');
const pzmobile02 = require('../../assets/images/publicize/mobile/pz-mobile02.jpg');
const pzmobile03 = require('../../assets/images/publicize/mobile/pz-mobile03.jpg');
const pzmobile04 = require('../../assets/images/publicize/mobile/pz-mobile04.jpg');
const pzmobile05 = require('../../assets/images/publicize/mobile/pz-mobile05.jpg');
const pzmobile06 = require('../../assets/images/publicize/mobile/pz-mobile06.jpg');



/**
 * 关于我们-基准方中宣传页
 */
const AboutUsPublicize = () => {

    const { isMobile } = useSelector((state: any) => state.reducer);

    if (isMobile) {
        return (
            <div className="company-aboutUs-publicize-wrapper">
                <img src={pzmobile01} loading="lazy" />
                <img src={pzmobile02} loading="lazy" />
                <img src={pzmobile03} loading="lazy" />
                <img src={pzmobile04} loading="lazy" />
                <img src={pzmobile05} loading="lazy" />
                <img src={pzmobile06} loading="lazy" />
            </div> 
        );
    }

    return (
        <div className="company-aboutUs-publicize-wrapper">
            <img src={publiciceBanner} loading="lazy" />
            <img src={publicize1} loading="lazy" />
            <img src={publicize2} loading="lazy" />
            <img src={publicize3} loading="lazy" />
            <img src={publicizeFooter} loading="lazy" />
        </div>
    );
};


export { AboutUsPublicize };